import ReactDOM from "react-dom";

export default function Modal({ children, show }) {
    if (!show) return null;

    const modalRoot = document.getElementById("modal-root");
    if (!modalRoot) return null;

    return (
        ReactDOM.createPortal(children, modalRoot)
    );
}